import { SHOW_AI_REPORTS_FOR } from '@src/constants'
import { useMemo } from 'react'
import useGetAccount from './useGetAccount'

export const useGetShowAIReports = () => {
  const account = useGetAccount()

  return useMemo(() => {
    const teams =
      SHOW_AI_REPORTS_FOR?.split(',')
        ?.map((id: string) => id?.trim())
        .filter(Boolean) || []

    if (!teams.length) {
      return true
    }
    if (account?.team) {
      return teams.includes(account?.team?.id?.toString())
    }

    return false
  }, [account])
}
